export default "__VITE_ASSET__BuvB1UTx__"